import { IonicModule } from '@ionic/angular';

/** El tipo de `IonicModule.forRoot()`, sin depender de `@ionic/core`, que no está en `package.json`. */
type IonicConfig = NonNullable<Parameters<typeof IonicModule.forRoot>[0]>;

/**
 * La configuración de Ionic de toda la app.
 *
 * **`mode: 'md'` en todas las plataformas** (31/10/2026). Sin esto, en un iPhone Ionic usa
 * `ios`, y en `ios` el `fill="outline"` de los campos no tiene efecto: todos los formularios
 * se veían como texto suelto, sin caja. La marca «Comanda» se diseñó y revisó en `md` (Android
 * y PC), así que el iPhone pasa a verse igual. Va global y no por página porque los overlays
 * (alertas, popovers, action sheets) cuelgan de `ion-app` y quedarían en `ios`.
 */
export const IONIC_CONFIG: IonicConfig = { mode: 'md' };
